module.exports = __webpack_public_path__ + "img/epc-track.3e2a22ec.svg";